import React, { useContext } from 'react'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

const Address = ({ formValues, setFormValues }) => {
  return (
    <Paper sx={{ padding: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="title">Address</Typography>
        </Grid>
        <Grid item xs={12} lg={6} xl={4}>
          <TextField
            label="Street Address"
            size="small"
            id="address-street"
            autoComplete="off"
            value={formValues?.employee?.personnelInfo?.address?.lineOne ?? ''}
            onChange={(event) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    address: {
                      ...prev.employee?.personnelInfo?.address,
                      lineOne: event.target.value,
                    },
                  },
                },
              }))
            }
            fullWidth
          />
        </Grid>
        <Grid item xs={12} lg={6} xl={4}>
          <TextField
            label="Street Address Line 2"
            size="small"
            autoComplete="off"
            id="address-street2"
            fullWidth
            value={formValues?.employee?.personnelInfo?.address?.lineTwo ?? ''}
            onChange={(event) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    address: {
                      ...prev.employee?.personnelInfo?.address,
                      lineTwo: event.target.value,
                    },
                  },
                },
              }))
            }
          />
        </Grid>
        <Grid item xs={12} lg={6} xl={4}>
          <TextField
            label="Town"
            size="small"
            id="address-town"
            fullWidth
            autoComplete="off"
            value={formValues?.employee?.personnelInfo?.address?.town ?? ''}
            onChange={(event) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    address: {
                      ...prev.employee?.personnelInfo?.address,
                      town: event.target.value,
                    },
                  },
                },
              }))
            }
          />
        </Grid>
        <Grid item xs={12} lg={6} xl={4}>
          <TextField
            label="City"
            size="small"
            id="address-city"
            fullWidth
            autoComplete="off"
            value={formValues?.employee?.personnelInfo?.address?.city ?? ''}
            onChange={(event) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    address: {
                      ...prev.employee?.personnelInfo?.address,
                      city: event.target.value,
                    },
                  },
                },
              }))
            }
          />
        </Grid>
        <Grid item xs={12} lg={6} xl={4}>
          <TextField
            label="County"
            size="small"
            id="address-county"
            fullWidth
            value={formValues?.employee?.personnelInfo?.address?.county ?? ''}
            autoComplete="off"
            onChange={(event) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    address: {
                      ...prev.employee?.personnelInfo?.address,
                      county: event.target.value,
                    },
                  },
                },
              }))
            }
          />
        </Grid>
        <Grid item xs={12} lg={6} xl={4}>
          <TextField
            label="Post Code"
            size="small"
            id="address-postCode"
            fullWidth
            value={formValues?.employee?.personnelInfo?.address?.postCode ?? ''}
            autoComplete="off"
            onChange={(event) =>
              setFormValues((prev) => ({
                ...prev,
                employee: {
                  ...prev.employee,
                  personnelInfo: {
                    ...prev.employee?.personnelInfo,
                    address: {
                      ...prev.employee?.personnelInfo?.address,
                      postCode: event.target.value,
                    },
                  },
                },
              }))
            }
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default Address
